
(function ($) {

    $(document).ready(function () {

        $(".custom-option").on("click", function () {
            if ($(this).parents('.js-articles-filter-bar').length) {
                loadArticles($(this).parents('.js-articles-filter-bar'), true);
            }
        });

        $(".custom-search").on("keyup", function (e) {
            if ($(this).parents('.js-articles-filter-bar').length) {
                loadArticles($(this).parents(".js-articles-filter-bar"), true);
            }
        });

        $(".load-more-button").on("click", function () {
            if ($(this).data("filterbar").length) {
                loadArticles($("#" + $(this).data("filterbar")), false);
            }
        });

    });

    function loadArticles(filterBar, reset = false) {
        var filters = {};
        filterBar.find(".custom-select").each(function () {
            var id = $(this).attr('id');
            if (id) filters[id] = $(this).val();
        });
        var results = $("#" + filterBar.data("results"));
        var loadmorebutton = $("#" + filterBar.data("loadmorebutton"));
        var count = parseInt(filterBar.attr("data-more"));
        var skip = reset ? 0 : parseInt(filterBar.attr("data-count"));
        filterBar.attr('data-count', skip + count);
        filters.count = count;
        filters.skip = skip;
        filters.parent = filterBar.find(".articles-parent").val();
        filters.article = filterBar.find(".articles-type").val();
        filters.search = filterBar.find(".custom-search").val();
        if ($(".js-neighbourhood-name").length > 0) {
            filters.neighbourhoods = $(".js-neighbourhood-name").val();
        }
        filters.isIgnoredPastEvents = filterBar.find(".ignored-past-events")?.val() ?? "false";
        results.find('.js-results-data').remove();

        $.ajax({
            url: "/umbraco/surface/Articles/RenderArticles",
            type: "GET",
            data: filters,
            success: function (response) {
                if (reset) {
                    results.html(response);
                } else {
                    results.find('.listings-entry:last').after(response);
                }
                if (results.find('.js-results-data').data('more') == 'True') {
                    loadmorebutton.show();
                } else {
                    loadmorebutton.hide();
                }

                $(".marker").hide();
                results.find('.listings-entry-map').each(function () {
                    var entry = $(this);

                    $(`.marker[data-article="${entry.attr('data-marker')}"]`).show();
                });
            }
        });

        if (filterBar.find("#year").length && filterBar.find("#month").length) {
            $.ajax({
                url: "/umbraco/surface/Articles/RenderMonths",
                type: "GET",
                data: filters,
                success: function (response) {
                    monthFilter = filterBar.find("#month").parent().find("div.custom-select.month");
                    if (response.disabled) {
                        monthFilter.addClass("disabled");
                        monthFilter.find(".custom-select-trigger").text("All");
                        monthFilter.find(".custom-option").removeClass("selection");
                        monthFilter.find(".custom-option[data-value='All']").addClass("selection");
                        filterBar.find("#month").val("All");
                    } else {
                        monthFilter.removeClass("disabled");
                        monthFilter.parent().find(".custom-options .custom-option").each(function () {
                            var option = $(this);
                            var month = option.attr("data-value");
                            if (response.months.includes(month) || month == "All") {
                                option.show();
                            } else {
                                option.hide();
                            }
                        });
                    }
                }
            });
        }

        if (filterBar.find("#location").length && filterBar.find("#suburb").length) {
            $.ajax({
                url: "/umbraco/surface/Articles/RenderSuburbs",
                type: "GET",
                data: filters,
                success: function (response) {
                    suburbFilter = filterBar.find("#suburb").parent().find("div.custom-select.suburb");
                    if (response.disabled) {
                        suburbFilter.addClass("disabled");
                        suburbFilter.find(".custom-select-trigger").text("All");
                        suburbFilter.find(".custom-option").removeClass("selection");
                        suburbFilter.find(".custom-option[data-value='All']").addClass("selection");
                        filterBar.find("#suburb").val("All");
                    } else {
                        suburbFilter.removeClass("disabled");
                        suburbFilter.parent().find(".custom-options .custom-option").each(function () {
                            var option = $(this);
                            var suburb = option.attr("data-value");
                            if (response.suburbs.includes(suburb) || suburb == "All") {
                                option.show();
                            } else {
                                option.hide();
                            }
                        });
                    }
                }
            });
        }
    }

})(jQuery);
